import type { PlanungUnavailability } from "@/lib/montageplanung";
import { unavailabilityLabelSpans } from "./unavailabilityUtils";

export function UnavailabilityReasonLabels({
  rowId,
  blocks,
  dayIsos,
  dayWidth,
}: {
  rowId: number;
  blocks: PlanungUnavailability[];
  dayIsos: string[];
  dayWidth: number;
}) {
  const spans = unavailabilityLabelSpans(rowId, blocks, dayIsos);
  if (spans.length === 0) return null;
  return (
    <>
      {spans.map((span) => (
        <div
          key={`unavail-reason-${span.id}`}
          className="mp-unavail-reason"
          style={{
            left: span.start * dayWidth + 2,
            width: Math.max(12, (span.end - span.start + 1) * dayWidth - 4),
          }}
        >
          <span>{span.text}</span>
        </div>
      ))}
    </>
  );
}
